<template>
  <CarvisDialog
    :show="true"
    @close="closeModal"
  >
    <div class="fixed inset-0 overflow-y-auto">
      <div class="flex min-h-full items-center justify-center p-4 text-center">
        <TransitionChild
          as="template"
          enter="duration-300 ease-out"
          enter-from="opacity-0 scale-95"
          enter-to="opacity-100 scale-100"
          leave="duration-200 ease-in"
          leave-from="opacity-100 scale-100"
          leave-to="opacity-0 scale-95"
        >
          <DialogPanel
            class="w-full md:max-w-md transform overflow-visible rounded-2xl bg-white p-6 text-left shadow-xl transition-all border-2 border-gray-400"
            role="dialog"
          >
            <div class="flex justify-between">
              <DialogTitle as="div">
                <CarvisH2>
                  <slot name="title">
                    Title
                  </slot>
                </CarvisH2>
              </DialogTitle>
              <Close
                class="cursor-pointer"
                @click="closeModal"
              />
            </div>

            <CarvisText class="mb-6">
              <slot />
            </CarvisText>

            <div class="col-span-full flex w-full items-center justify-end gap-x-6">
              <slot name="actions">
                <slot name="secondary-button">
                  <CarvisButton
                    block
                    @click="closeModal"
                  >
                    <slot name="secondary-button-text">
                      Abbrechen
                    </slot>
                  </CarvisButton>
                </slot>
                <slot name="primary-button">
                  <CarvisButton
                    block
                    color="primary"
                  >
                    <slot name="primary-button-text">
                      Bestätigen
                    </slot>
                  </CarvisButton>
                </slot>
              </slot>
            </div>
          </DialogPanel>
        </TransitionChild>
      </div>
    </div>
  </CarvisDialog>
</template>

<script setup lang="ts">
import {
  DialogPanel,
  DialogTitle,
  TransitionChild
} from '@headlessui/vue'
import { inject } from 'vue'
import Close from 'vue-material-design-icons/Close.vue'

import { useModalsStore } from '@/stores/modals-store'

const modalsStore = useModalsStore()
const modalId = inject<string>('modalId')

const closeModal = (): void => {
  if (modalsStore.currentModalId === modalId) {
    modalsStore.closeModal()
  }
}
</script>
